import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AssetType } from '../../enums/asset-type.enum';

export interface MediaPreviewItem {
  url: string;
}

@Component({
  selector: 'dal-shared-ui-assetpreview',
  templateUrl: './assetpreview.component.html',
  styleUrl: './assetpreview.component.scss',
})
export class AssetpreviewComponent implements OnInit {
  @Input() mediaFiles: MediaPreviewItem[] = [];
  @Input() assetTypeId: number = 0;
  showCloseButton = false;
  url: string = '';
  assetType: number;

constructor(private router: Router, private route: ActivatedRoute, ) { }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe((params) => {
      this.url = params.get('imageUrl') ?? '';
      this.assetTypeId = parseInt(params.get('assetType') || '0', 10);
    });
  }

  getMediaType(): string {
    switch (this.assetTypeId) {
      case 1:
        return AssetType[1].toLowerCase();
      case 2:
        return AssetType[2].toLowerCase();
      case 3:
        return AssetType[3].toLowerCase();
      case 4:
        return AssetType[4].toLowerCase();
      default:
        return AssetType[5].toLowerCase();
    }
  }

  openImageInNewTab(url: string | undefined): void {
    if (!url) {
      return;
    }
    window.open(`/preview?imageUrl=${encodeURIComponent(url)}&assetType=${this.assetTypeId}`, '_blank');
  }

  isPreviewRoute(): boolean {
    return this.router.url.includes('/preview?imageUrl');
  }

  isPreviewOpen: boolean = false;

  openPreview() {
    this.isPreviewOpen = true;
  }

  closePreview() {
    this.isPreviewOpen = false;
    window.close();
  }

}
